export const THEME_LIGHT = "Light";
export const THEME_DARK = "Dark";
export const THEME_OVERRIDE_STORAGE_KEY = "cemTheme";

const isBlank = (value) => value === null || value === undefined || value === "";

const getStorage = (storageName) => {
  try {
    return globalThis?.[storageName] ?? null;
  } catch {
    return null;
  }
};

export const normalizeTheme = (theme) => {
  if (isBlank(theme)) {
    return THEME_LIGHT;
  }

  switch (theme.toString().trim().toLowerCase()) {
    case "light":
      return THEME_LIGHT;
    case "dark":
      return THEME_DARK;
    default:
      return THEME_LIGHT;
  }
};

export const resolveEffectiveTheme = ({
  savedTheme,
  themeOverride = null,
}) => normalizeTheme(themeOverride ?? savedTheme);

export const getThemeDatasetValue = (theme) =>
  normalizeTheme(theme) === THEME_DARK ? "dark" : "light";

export const readThemeOverride = () => {
  const localStorage = getStorage("localStorage");
  const storedValue = localStorage?.getItem(THEME_OVERRIDE_STORAGE_KEY);

  if (isBlank(storedValue)) {
    return null;
  }

  return normalizeTheme(storedValue);
};

export const writeThemeOverride = (theme) => {
  const localStorage = getStorage("localStorage");
  if (!localStorage) {
    return;
  }

  localStorage.setItem(THEME_OVERRIDE_STORAGE_KEY, normalizeTheme(theme));
};

export const clearThemeOverride = () => {
  const localStorage = getStorage("localStorage");
  localStorage?.removeItem(THEME_OVERRIDE_STORAGE_KEY);
};
